import axios from 'axios';
import moment from 'moment';
import safeLocalStorage from '../../helpers/safeLocalStorage';

const questionaryStorageKey = 'new-questionary-date';

class SearchQuestionary {
  constructor() {
    this.node = document.getElementById('search-questionary');
    if (!this.node) return;
    this.questionNode = this.node.querySelector('[data-search-questionary]');
    this.successNode = this.node.querySelector('[data-search-questionary-success]');
    this.prevQuestionaryDate = safeLocalStorage.getItem(questionaryStorageKey);

    this.fetchQuestionary();
  }

  fetchQuestionary = () => {
    axios({
      url: `/api/v2/questionary/get`,
      method: 'get',
    })
      .then(({ data }) => {
        this.formattedDate = moment(data.createdAt).format('DD-MM-YYYY');

        if (data.isActive && this.formattedDate !== this.prevQuestionaryDate) {
          if (this.prevQuestionaryDate) {
            safeLocalStorage.removeItem(questionaryStorageKey);
          }

          this.node.classList.remove('hidden');
          this.attachListeners();
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  attachListeners = () => {
    const answerButtons = [...this.node.querySelectorAll('[data-search-questionary-answer]')];
    const closeButton = this.node.querySelector('[data-search-questionary-close]');

    answerButtons.forEach(button => {
      button.addEventListener('click', () => {
        this.saveAnswer(button.dataset.searchQuestionaryAnswer);
      });
    });

    closeButton.addEventListener('click', () => {
      if (this.formattedDate) {
        safeLocalStorage.setItem(questionaryStorageKey, this.formattedDate);
      }
      this.node.classList.add('hidden');
    });
  };

  saveAnswer = (answer) => {
    this.questionNode.classList.add('hidden');
    this.successNode.classList.remove('hidden');

    axios({
      url: `/api/v2/questionary/answer/save`,
      method: 'post',
      data: {
        regionId: Number(window.params.regionId),
        cityId: Number(window.params.cityId),
        page: decodeURI(window.location.pathname),
        marketType: 'primary',
        answer,
      },
    })
      .then(() => {
        safeLocalStorage.setItem(questionaryStorageKey, this.formattedDate);
      })
      .catch((error) => {
        console.error(error);
      });
  };
}

new SearchQuestionary();
